import styled from '@emotion/styled'

import media from '../../../../styles/media'

const S = {}

S.V1Language = styled.div`
  position: relative;
  cursor: pointer;
  font-size: 0.875rem;
  width: 100%;
  line-height: 1.5;
  transition: background-color 0.15s linear;

  ${media.md`
    margin-left: auto;
    margin-right: auto;
    width: 15.625rem;
  `};

  .language {
    &-current {
      display: flex;
      align-items: center;
      justify-content: space-between;
      user-select: none;
      padding: 0.75rem;
      box-sizing: border-box;
      transition: 0.2s ease-in-out;
      transition-property: background-color, color;

      html:not([dir]) &,
      [dir='ltr'] & {
        padding-left: 1rem;
      }

      [dir='rtl'] & {
        padding-right: 1rem;
      }

      .triangle-svg {
        transform: ${({ isOpen }) => isOpen && 'rotate(180deg)'};
        transition: transform 0.3s ease-in-out, fill 0.2s ease-in-out;
      }
    }

    &-list {
      position: absolute;
      width: 100%;
      bottom: 2.8125rem;
      list-style-type: none;
      margin: 0;
      padding: 0;
      display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
      box-sizing: border-box;
      z-index: 10;
      border-bottom: ${({ isLangFiltered }) => isLangFiltered && 'none'};

      html:not([dir]) &,
      [dir='ltr'] & {
        text-align: left;
      }

      [dir='rtl'] & {
        text-align: right;
      }
    }

    &-item {
      padding: 0.75rem 1rem;
      transition: 0.2s ease-in-out;
      transition-property: background-color, color;
    }
  }
`

export default S
